var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M610.5 822L-46 424V287.5L167.5 138.5L840.5 201.5L610.5 822Z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1880.5 777.5L954 453.5V317L1167.5 168L1840.5 231L1880.5 777.5Z",
    fill: "#ECECEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-25.5 1048.5L-47 609.5L89 497.5L477 740L636.5 1048.5H-25.5Z",
    fill: "#F1F1F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192 140.5L-22 275V-25.4999L192 -14.4999V140.5Z",
    fill: "#F6F6F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-42.5 272L170 137L514 165.5L-128.5 685L-42.5 272Z",
    fill: "#F3F3F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M171.5 142L514 168.5L744.5 -84.9999L145 -46.9999L171.5 142Z",
    fill: "#F1F1F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M636.486 744.129L559.968 476.347L1135.21 -233L1598 91.5001L636.486 744.129Z",
    fill: "#F1F1F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1022 -93L787.5 198.5L622 215L507.5 170.5L776.5 -113L1022 -93Z",
    fill: "#F6F6F6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M652.5 367.5L92.5 1050.5H770L652.5 367.5Z",
    fill: "#F6F6F6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M694 697.5L732.5 758.5L544 1055L1182 1088.5L857.5 594.5L694 697.5Z",
    fill: "#F1F1F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1161.5 1046L831.5 576.5L1025.5 449L1507 625V1046H1161.5Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetBg);
export default __webpack_public_path__ + "static/media/ResetBg.f1747aad55ba81617710b5d3a309474d.svg";
export { ForwardRef as ReactComponent };